//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { ITrackableComponent, withTracking } from '@utils/withTracking';

interface Props
  extends React.HTMLAttributes<HTMLTableRowElement>,
    ITrackableComponent {
  children: React.ReactNode;
}

/**
 * This component exists for the purpose of standardizing a table's rows `<tr>`.
 *
 * @param children A component rendering the contents of a table row.
 * `TableMediaAndTimeCell`, `TableDataCell`, and `TableHeaderCell` components should be used as children.
 */
export const TableRow = ({
  children,
  className,
  trackingId,
  ...rowProps
}: Props) => {
  return (
    <StyledTR className={className} trackingId={trackingId} {...rowProps}>
      {children}
    </StyledTR>
  );
};

const StyledTR = withTracking(
  styled.tr(
    ({ theme }) => `
    border: ${theme.borderWidths[1]} solid ${theme.colors.gray1};
    
    &:nth-child(even) {
      background-color: ${theme.colors.gray0};
    }
    &:nth-child(odd) {
      background-color: ${theme.colors.white};
    }
  `,
  ),
);
